import { render, staticRenderFns } from "./InventoryItemInformation.vue?vue&type=template&id=8f6729b4&scoped=true"
import script from "./InventoryItemInformation.vue?vue&type=script&lang=js"
export * from "./InventoryItemInformation.vue?vue&type=script&lang=js"
import style0 from "./InventoryItemInformation.vue?vue&type=style&index=0&id=8f6729b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6729b4",
  null
  
)

export default component.exports